import React from "react";

const ChatMessageOg = ({ title, url, description, defaultImage, onClick }) => (
  <a href={url} target="_blank" onClick={onClick}>
    <p>
      <img
        src={defaultImage?.url}
        alt={defaultImage?.alt}
        onError={(e) => {
          e.target.style.display = "none";
        }}
      />
    </p>
    <p className="mt-2 text-lg font-semibold text-black">{title}</p>
    <p>{description}</p>
    <p className="mt-1 text-sm break-all whitespace-pre-line text-neutral-400">
      여기를 눌러 링크를 확인하세요. <br />
      {url}
    </p>
  </a>
);

export default ChatMessageOg;
